import Modal from './Modal'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'


function ProductInfo(props) {
    const [modal, setModal] = useState(false)
    const { refProduct_information } = props.route

    const renderHashInfo = () => {

        let html =<ul className='modalListInfo p-3'>
            {refProduct_information && refProduct_information.length > 0 && refProduct_information.map((item) => {
                return <li className='customShadow customRadius mb-4' key={item.id}>
                    <h2 class="listInfoTitle">{item?.headline}</h2>
                    <p  class="listInfoDescp">{item?.text}</p>
                </li>
            })}
        </ul>

        return <div>
            {html}
        </div>
    }

    return <li className="beigeBox customShadow customRadius px-1 py-3 beigeBoxPointer">
            <div className="d-flex w-100 align-items-center justify-content-between" onClick={() => setModal(!modal)}>
                <div className='beigeBoxOnlyTitleWrap'>
                    
                    <h3>Product<br/>Information</h3>
                </div>
                <div className='beigeBoxOnlyIconWrap p-0'>
                    <FontAwesomeIcon icon={faInfoCircle}  />
                </div>
            </div>
            
        {modal && <Modal title="Product Information" modal={modal} toggleModal={setModal}>{renderHashInfo()}</Modal>}
    </li>
}


export default ProductInfo